import script from "./GmxAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxAlert.vue?vue&type=script&setup=true&lang=js"

import "./GmxAlert.vue?vue&type=style&index=0&id=59bf65e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bf65e4"]])

export default __exports__